// extracted by mini-css-extract-plugin
export default {"title":"vPGRIOKIUc1fT1hz0EXw","menuList":"ToRZ6k8hnSXEEmNvp9sS","image":"mUVOeLbcMuSbcCJw9GsS"};